import React from 'react'
import { Box } from 'components/layout/Box/Box'

import ebberLogo from 'images/ebber.png'

import styles from './BackCover.module.scss'
import reportStyles from '../../Report.module.scss'

export const BackCover = () => (
  <Box className={reportStyles.container}>
    <div className={reportStyles.fold} />
    <div className={styles.logo}>
      <img alt="ebber" src={ebberLogo} />
    </div>
  </Box>
)
